import { common } from './common';

export const zhTW = {
  common,
};